import HeaderNavItem from './HeaderNavItem';
import { headerMenus } from './HeaderData';

const HeaderNav = () => {
  return (
    <div className="flex items-center gap-10">
      {headerMenus.map((menu) => (
        <HeaderNavItem key={menu.id} icon={menu.icon} label={menu.label} path={menu.path} />
      ))}
    </div>
  );
};

export default HeaderNav;
